/* eslint-disable no-unused-vars */
import { observer } from "mobx-react"
import React, { useEffect, useRef,createRef } from "react"
import "./App.less"
import "./styles/Common/common.less"
import { Background, Benefits, Header, IncomePlan, TalkToExpertModal, SuitabilityModal, Resultplan, ResultBlock, PlanBenefits, WhatIs, HowItWorks, Steps, Disclaimer, FAQ, HowToCalc,CallUs, PlanTypes, StepsGuide } from "./Components"
import { UserInput } from "./Configs/API/calculation"
import { ipAPI, DataLayerFn } from "./Configs/API"
import AppStore from "./Configs/Store"
import FormStore from "./Configs/Store/forms"
import CalculatorStore from "./Configs/Store/calculator"
import CalculationAPI from "./Configs/API/calculation"
import KnowMoreModal from "./Components/GuaranteedIncome/KnowMoreModal"
import { ageValidation } from "./Configs/Validator/FormValidations"
import MuiltiProducts from "./Components/Common/MultiProducts"
import RetirmentPlans from "./Components/RetirmentPlans/RetirmentPlans"
import WhyUs from "./Components/WhyUs/WhyUs"
import Footer from "./Components/Footer/Footer"
import ChoosePlan from "./Components/ChoosePlan/ChoosePlan"
import PensionBenefits from "./Components/BuyingBenefits"
const App = observer((props) => {
  const params = new URLSearchParams(window.location.search)
  const faqRef = createRef()

  useEffect(() => {
    const token = params.get("retireCalc")
    CalculatorStore.setSearchParams(token)
    UserInput("productId", token, "", "")
  })

  useEffect(() => {
    const collectIp = async () => {
      const ip = await ipAPI()
      AppStore.setIpAddress(ip["origin"])
      window.ipAddress = ip["origin"]
      localStorage.recent_product = "SIGNATURE_dynamic"
    }

    const handleResize = (e) => {
      const width = window.innerWidth
      const height = window.innerHeight
      var isLocalHost = window.location.hostname === "localhost"

      AppStore.setWindowWidth(width)
      AppStore.setWindowHeight(height)
      AppStore.setLocalHost(isLocalHost)
      if (width <= 900) {
        AppStore.setDevice(0)
      } else {
        AppStore.setDevice(1)
      }

      if (!isLocalHost) {
        // console.info = () => {}
      }
    }

    const scrollPast = async (e) => {
      var elementTarget = document.getElementsByClassName("GuaranteedIncome_Background")[0]
      if (window.scrollY > elementTarget.offsetTop + elementTarget.offsetHeight - 100) {
        AppStore.setFrameFooter(true)
      } else {
        AppStore.setFrameFooter(false)
      }
    }

    PersonaVerfication()
    handleResize()
    window.addEventListener("resize", handleResize)
    window.addEventListener("scroll", scrollPast)

    collectIp()
    // DataLayerFn("Landed||Calculator-Landing page", CalculatorStore, "")
    DataLayerFn("Landed", CalculatorStore, "")

    setTimeout(() => {
      document.querySelector(".Spinner_Background").style.display = "none"
      var spinner = document.querySelector("body").classList
      if (spinner.contains("Spinner_Default")) spinner.remove("Spinner_Default")
    }, 3000)

    return () => {
      window.removeEventListener("resize", handleResize)
      window.removeEventListener("scroll", scrollPast)
    }
  }, [])

  useEffect(() => {
    if (window.UserInput.screen === "Scr6") {
      CalculatorStore.setCustomRange1Text("Retirement Age")
      CalculatorStore.setminValue(40)
      CalculatorStore.setRangeInput(60)
      CalculatorStore.setbgSize(((60 - 40) / (CalculatorStore.maxValue - 40)) * 100)
    } else {
      CalculatorStore.setCustomRange1Text("Age")
      CalculatorStore.setminValue(18)
      CalculatorStore.setRangeInput(43)
      CalculatorStore.setAgeValue(43)
      UserInput("age", 43, "", "")
      CalculatorStore.setbgSize(((43 - 18) / (CalculatorStore.maxValue - 18)) * 100)
    }
  }, [])

  const PersonaVerfication = () => {
    var MAIN_URL = window.location.href
    var URL_OBJ = new URL(MAIN_URL)
    var personaType = URL_OBJ.searchParams.get("persona")
    var tempTypeVal = "Wealth"
    var isPersonaValid = true
    // console.info("personaType :", personaType)
    if (personaType) {
      if (personaType === "Sig-Wealth") {
        tempTypeVal = "Wealth"
        isPersonaValid = true
      } else if (personaType === "Sig-Retire") {
        tempTypeVal = "Retirement"
        isPersonaValid = true
      } else if (personaType === "Sig-Child") {
        tempTypeVal = "Child"
        isPersonaValid = true
      } else {
        isPersonaValid = false
      }
    } else {
      isPersonaValid = false
    }

    if (tempTypeVal !== "") {
      // Always True
      FormStore.setCalcType(tempTypeVal)
      UserInput("calcType", "key", tempTypeVal)
      FormStore.setPersonaValidity(isPersonaValid)
    } else {
      FormStore.setPersonaValidity(false)
    }
  }

  const changeScreen = (param) => {
    CalculatorStore.setCalcPageScrn(param)
  }

  const handleAgeVal = (event) => {
    let regEx1 = /^0+/
    let regEx2 = /^[0-9\b]+$/
    let evt = event.target.value
    const customRangeInputMin = event.target.min
    const customRangeInputMax = event.target.max
    let substr = evt.replace(CalculatorStore.currentChar, "")
    let value = regEx2.test(evt) === true ? evt.toString().replace(regEx1, "") : substr
    let age = value === "" || isNaN(value) ? 0 : value
    let flag = ageValidation(age, CalculatorStore.minValue, CalculatorStore.maxValue)

    event.preventDefault()
    if (CalculatorStore.screenNo === "Scr6") {
      CalculatorStore.setminValue(40)
      CalculatorStore.setRetireAgeValue(age)
      UserInput("ageOfRetirement", age, "", "")
      CalculationAPI(CalculatorStore.ageValue, CalculatorStore.currentExpensesValue1, CalculatorStore.currentExpensesValue2, CalculatorStore.currentExpensesValue3, age)
    } else {
      CalculatorStore.setminValue(18)
      CalculatorStore.setAgeValue(age)
      UserInput("age", age, "", "")
      CalculatorStore.setIsDisabled(true)
      CalculatorStore.setManageStateForSlider(true)

      if (flag.valid || CalculatorStore.screenNo === "Scr1") {
        if (CalculatorStore.screenNo === "Scr1" && flag.valid) {
          CalculatorStore.setCustomRange1Text("Age")
          CalculatorStore.setRetireAgeValue(60)
          CalculatorStore.setIsDisabled(false)
        }

        CalculationAPI(age, CalculatorStore.currentExpensesValue1, CalculatorStore.currentExpensesValue2, CalculatorStore.currentExpensesValue3, CalculatorStore.retireAgeValue)
        CalculatorStore.setManageStateForSlider(false)
      }
    }
    CalculatorStore.setRangeInput(age)

    if (event.target.name === "ageInput") {
      let trgtvalfinal = (evt - CalculatorStore.minValue) * (100 / (CalculatorStore.maxValue - CalculatorStore.minValue))
      trgtvalfinal > 0 ? CalculatorStore.setbgSize(trgtvalfinal) : CalculatorStore.setbgSize(0)
    } else {
      CalculatorStore.setbgSize(((evt - customRangeInputMin) / (customRangeInputMax - customRangeInputMin)) * 100)
    }

    CalculatorStore.setErrorAge(flag.valid)
    CalculatorStore.setErrorMessage(flag.errorMsg)
    flag.valid === false ? CalculatorStore.setIsDisabled(true) : CalculatorStore.setIsDisabled(false)
    CalculatorStore.ageValue > CalculatorStore.retireAgeValue ? CalculatorStore.setAgeRetireCalc(true) : CalculatorStore.setAgeRetireCalc(false)
    console.log("Age : ", age)
  }

  return (
    <>
      <Header type={0} />
      <TalkToExpertModal />
      <SuitabilityModal />
      <section
        className={`common-section guranteed-inc-section ${CalculatorStore.screenNo}`}
        // style={{ height: CalculatorStore.screenNo === "Scr6"  ? "auto" : "382px" }}
      >
        <div className="container">
          <div className="row">
            <div className="col-12">
              <Background personaType={FormStore.calc_type["key"]}>
                <div className="IncomeMain">
                  <div className="IncomeRoot">
                    {CalculatorStore.calc_pagescrn === "last" ? (
                      <>
                        <Resultplan personaType={FormStore.calc_type["key"]} />
                        <ResultBlock handleAgeVal={handleAgeVal} changeScreen={changeScreen} />
                      </>
                    ) : (
                      <>
                        <IncomePlan personaType={FormStore.calc_type["key"]} />
                        <Benefits handleAgeVal={handleAgeVal} changeScreen={changeScreen} />
                      </>
                    )}
                  </div>
                </div>
              </Background>
            </div>
          </div>
        </div>
      </section>
      <WhatIs />
      <HowToCalc/>
      <HowItWorks />

      <PlanBenefits />
      <Steps />
      <StepsGuide/>
      <PlanTypes/>
      <PensionBenefits/>
      <ChoosePlan/>
      <WhyUs/>
      <FAQ sectionRef={faqRef} deviceType={AppStore.device} />
      <Disclaimer />
      {/* <Footer /> */}
    </>
  )
})

export default App
